import { Button, CityState, DataSource, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommPositionTable extends Layout {
    buttonFindNear: Button;
    buttonMessage: Button;
    sourceMobileCommPosition: DataSource;
    tableMobileCommPosition: Table;
    textboxCity: CityState;
    textboxRadius: Textbox;
}
